
let str = 'http://www.hifdaedu.com/info/info/'
var utils = {
    params: {
        Cardid:'',
        WorkName:'',
        Sex:'',
        NATION:'',
        MEDULEVEL:'',
        MEDUSPEC:'',
        MEDUSCHOOL:'',
        byzpic:'',
        
        technicOne:'',
        sort:'',
        ExtentOne:'',
        QualiCode:'',
        ATTEYEAR:'',
        zQualiCode:'',
        zATTEYEAR:'',
        WorkUnit:'',
       
        ExtentTwo:'',
        NATIVEPLACE:'',
        zgzpic:'',
        zzgzpic:'',

        address:'',
        postalcode:'',
        HANDSETPHONE:'',
        LINKPHONE:'',
        email:'',
    },
    IEVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            return false
        } else if(isEdge) {
            return false//edge
        } else if(isIE11) {
            return true; //IE11  
        }else{
            return true;//不是ie浏览器
        }
    },
    isIE() {
        if(!!window.ActiveXObject || "ActiveXObject" in window){
          return true;
        }else{
          return false;
    　　 }
    },
    endStudy () {
        return true
        // let date = new Date()
        // let m = date.getMonth() + 1
        // if (m > 0 && m != 12) {
        //     return true
        // } else {
        //     return false
        // }
    },
    getTime () {
        return false;
        // let date = new Date()
        // let m = date.getMonth() + 1
        // let d = date.getDate()
        // if (m > 11 && d> 20) { 
        //     return true
        // } else {
        //     return false
        // }
    },
    download:[
        //2022年新课件
        {INFONAME:'2022年药品质量管理继续教育培训课件',url:str+'2022年药品质量管理继续教育培训课件.zip'},
        {INFONAME:'2021年海南省中药饮片经营企业质量管理培训班课件',url:str+'2021年海南省中药饮片经营企业质量管理培训班课件.zip'},
        {INFONAME:'2021年药品经营企业质量管理人员继续教育培训课件',url:str+'2021年药品经营企业质量管理人员继续教育培训课件.zip'},
        {INFONAME:'2021年医疗器械继续教育培训课件',url:str+'2021年医疗器械继续教育培训课件.zip'},
        {INFONAME:'特殊制剂及临床营养研发策略及实践培训班课件',url:str+'特殊制剂及临床营养研发策略及实践培训班课件.zip'},
        {INFONAME:'制药行业仪器与分析检测技术发展交流会课件',url:str+'制药行业仪器与分析检测技术发展交流会课件.zip'},
        {INFONAME:'药品流通GSP专题培训班课件',url:str+'药品流通GSP专题培训班课件.zip'},
      
    ],
   
    newsType :[
        {'name':'首页',id:'Index',class:'nav-1',dlb:'11'},
        {'name':'继续教育',id:'List',class:'nav-3',dlb:'1000210001'},
        {'name':'学历教育',id:'List',class:'nav-4',dlb:'1000410001'},
        {'name':'职业培训',id:'List',class:'nav-2',dlb:'1000510001'},
        // {'name':'技能鉴定',id:'List',class:'nav-5',dlb:'1000310001'},
        // {'name':'健康管理师',id:'List',class:'nav-5',dlb:'1000710001'},
        {'name':'药监要闻',id:'List',class:'nav-8',dlb:'1000810001'},
        // {'name':'人才交流',id:'List',class:'nav-6',dlb:'1000710002'},
        {'name':'学分查询',id:'xfCard',class:'nav-7',dlb:'10006'},
    ],
    indexList : [
        {'name':'党建设',id:'List',class:'nav-9',dlb:'1000910001'},
        // {'name':'健康管理师',id:'List',class:'nav-2',dlb:'1000710001'},
        {'name':'继续教育',id:'List',class:'nav-3',dlb:'1000210001'},
        {'name':'学历教育',id:'List',class:'nav-4',dlb:'1000410001'},
        {'name':'职业培训',id:'List',class:'nav-2',dlb:'1000510001'},
        {'name':'法规信息',id:'List',class:'nav-6',dlb:'1000610002'},
        // {'name':'技能鉴定',id:'List',class:'nav-5',dlb:'1000310001'},
        // {'name':'人才交流',id:'List',class:'nav-6',dlb:'1000710002'},
    ],
    newsTypeAll :[
        // {'name':'首页',id:'Index',class:'nav-1',dlb:'11'},
        {'name':'图片新闻',id:'xfCard',class:'nav-7',dlb:'1000110002'},
        {'name':'重要通知',id:'List',class:'nav-2',dlb:'1000110001'},
        {'name':'继续教育',id:'List',class:'nav-3',dlb:'1000210001'},
        {'name':'学历教育',id:'List',class:'nav-4',dlb:'1000410001'},
        // {'name':'健康管理师',id:'List',class:'nav-2',dlb:'1000710001'},
        {'name':'职业培训',id:'List',class:'nav-2',dlb:'1000510001'},
        {'name':'法规信息',id:'List',class:'nav-6',dlb:'1000610002'},
        {'name':'技能鉴定',id:'List',class:'nav-5',dlb:'1000310001'},
        {'name':'药监要闻',id:'List',class:'nav-8',dlb:'1000810001'},
        {'name':'党建设',id:'List',class:'nav-9',dlb:'1000910001'},
        // {'name':'人才交流',id:'List',class:'nav-6',dlb:'1000710002'},
       

        {'name':'学分查询',id:'xfCard',class:'nav-7',dlb:'10006'},
        {'name':'搜索列表',id:'Search',class:'nav-7',dlb:'10014'},
        {'name':'下载专区',id:'other',class:'nav-7',dlb:'10015'},
        {'name':'微视频',id:'other',class:'nav-7',dlb:'10016'},
        {'name':'中心简介',id:'other',class:'nav-7',dlb:'12'},
    ],
    health:[
        {INFONAME: "2019年三级健康管理师考前辅导班招生简章",time:'2019-09-25',id: "1590",url: "https://mp.weixin.qq.com/s/fjLRKTUBruGFxvLc41l9Gg"},
        {INFONAME: "健康管理师证书值得考吗？",INFO: "01",time:'2019-07-31',pic: "https://mp.weixin.qq.com/s/fjLRKTUBruGFxvLc41l9Gg"},
        {INFONAME: "拿到健康管理师资格证的，现在都在做什么？",time:'2019-07-31',INFO: "02",pic: "https://mp.weixin.qq.com/s/fjLRKTUBruGFxvLc41l9Gg"},
    ],
    formDate2:{
        WORKNAME: {
            'name': '姓名','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        CARDID: {
            'name': '证件号码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        SEX:{
            'name': '性别','value':'','option':'sex','showSelect':true,'select':['男','女']
        },
        STUDYLEVEL:{
            'name':'学历','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        WorkUnit:{
            'name':'工作单位','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        HANDSETPHONE:{
            'name':'手机号码','value':'','placeholder':'请填写',option:'mobilePhone','showSelect':false
        },
        JOBLEVEL:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','助理级','员级','无'],
        },
        ADDRESS:{
            'name':'通讯地址','value':'','placeholder':'请填写',option:'graduation','showSelect':false
        },
        WORKPHONE:{
            'name':'单位电话','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        WORKSTATION:{
            'name':'岗位','value':'',option:'education','showSelect':true,'select':
            ['企业负责人','质量管理','技术人员','养护员','采购员','仓管','验收','维修','营销'],
        },
        zw:{
            'name':'职务','value':'','placeholder':'请填写',option:'email','showSelect':false,
        },
        QUALICODE:{
            'name':'药品经营许可证号','value':'','placeholder':'请填写',option:'email','showSelect':false,
        },
        BIRTHDAY:{
            'name':'出生年月','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
    },
    //没有 QualiCode:'', ATTEYEAR:'',zATTEYEAR zQualiCode:'',zgzpic:'',zzgzpic:'',
    formDate:{
        sf: {
            'name': '(省/市)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        sx: {
            'name': '(市/县)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        xq: {
            'name': '(县/区)','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        WorkName: {
            'name': '姓名','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Cardid: {
            'name': '证件号码','value':'','placeholder':'请填写','option':'userName','showSelect':false
        },
        Sex:{
            'name': '性别','value':'','option':'sex','showSelect':true,'select':['男','女']
        },
        educity:{
            'name':'属地（市）','value':'',option:'eduadd','showSelect':true,'select':[
                '海口','三亚','琼海','儋州','洋浦','东方','五指山','万宁','文昌','屯昌','保亭','临高','定安','乐东',
                '白沙','琼中','陵水','昌江','澄迈','省外市'
            ]
        },
        NATIVEPLACE: {
            'name': '注册工作属地','value':'','placeholder':'请填写','option':'userName','showSelect':true,'select':[
                '海口','三亚','琼海','儋州','洋浦','东方','五指山','万宁','文昌','屯昌','保亭','临高','定安','乐东',
                '白沙','琼中','陵水','昌江','澄迈','省外市']
        },
        NATION:{
            'name':'民族','value':'',option:'NATION','showSelect':true,'select':
            ['汉族','蒙古族','回族','藏族','维吾尔族','彝族','壮族','布依族','朝鲜族','傣族',
            '德昂族','满族','侗族','瑶族','白族','土家族','哈尼族','景颇族', '哈萨克族','黎族',
            '傈僳族','畲族','高山族','拉祜族','水族','东乡族','纳西族','柯尔克孜族','土族','达斡尔族',
            '仫佬族','羌族','布朗族', '撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族',
            '怒族','乌孜别克族','俄罗斯族','鄂温克族','塔塔尔族','独龙族', '鄂伦春族','赫哲族','门巴族', '珞巴族',
            '基诺族','保安族','京族','佤族','裕固族','苗族'],
        },
        MEDULEVEL:{
            'name':'学历','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        MEDUSPEC:{
            'name':'专业','value':'',option:'education','showSelect':true,'select':['中药学','药学','相关专业'],
        },
        sort: {
            'name':'证书类型','value':'',option:'certificate','showSelect':true,'select':['执业药师','从业药师',''],
        },
        ExtentOne:{
            'name':'执业类别','value':'',option:'operation','showSelect':true,'select':['药学','中药学','药学和中药学'],
        },
        QualiCode:{
            'name':'西药证书编号','value':'',option:'operation','showSelect':false,type:'date'
        },
        zQualiCode:{
            'name':'中药证书编号','value':'',option:'operation','showSelect':false,type:'date'
        },
        ATTEYEAR: {
            'name':'西药证书考取考取年份','value':'','placeholder':'请填写，如：考试年月',option:'time','showSelect':false
        },
        zATTEYEAR: {
            'name':'中药证书考取年份','value':'','placeholder':'请填写',option:'time','showSelect':false
        },
       
        ExtentTwo:{
            'name':'执业范围','value':'',option:'operatorScope','showSelect':true,'select':
            ['生产','批发','零售','使用','检验','其他','无'],
        },
        WorkUnit:{
            'name':'工作单位','value':'','placeholder':'请填写',option:'company','showSelect':false
        },
        HANDSETPHONE:{
            'name':'手机号码','value':'','placeholder':'请填写',option:'mobilePhone','showSelect':false
        },
        MEDUSCHOOL:{
            'name':'毕业学校','value':'','placeholder':'请填写',option:'school','showSelect':false
        },
        MEDUTIME:{
            'name':'毕业时间','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        technicOne:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','员级','卫生技术人员','无'],
        },
        JOBLEVEL:{
            'name':'职称','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        WorkStat:{
            'name':'从事岗位','value':'','placeholder':'请填写',option:'station','showSelect':false
        },
        address:{
            'name':'通讯地址','value':'','placeholder':'请填写',option:'graduation','showSelect':false
        },
        postalcode:{
            'name':'邮政编码','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        LINKPHONE:{
            'name':'单位电话','value':'','placeholder':'请填写',option:'phone','showSelect':false
        },
        email:{
            'name':'电子邮箱','value':'','placeholder':'请填写',option:'email','showSelect':false
        },
        grjl:{
            'name':'个人简历','value':'','placeholder':'请填写',option:'email','showSelect':false,typpe:'textarea'
        },
        WORKSTATION:{
            'name':'岗位','value':'',option:'education','showSelect':true,'select':
            ['博士研究生','硕士研究生','本科','大专','中专','高中','初中'],
        },
        zw:{
            'name':'职务','value':'','placeholder':'请填写',option:'email','showSelect':false,
        },
        QUALICODE:{
            'name':'药品经营许可证号','value':'','placeholder':'请填写',option:'email','showSelect':false,
        },
        BIRTHDAY:{
            'name':'出生年月','value':'','placeholder':'请填写',option:'graduation','showSelect':true,type:'date'
        },
        byzpic:{
            'name':'毕业证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zgzpic:{
            'name':'西药资格证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
        zzgzpic:{
            'name':'中药资格证书照片','value':'',option:'specialLevel','showSelect':true,'select':['正高级','副高级','中级','初级','无'],
        },
    },
    gqpx (str) {
        let num;
            if (str === '100' || str == '6') {//器械
                num = 'YLQX'
            } else if (str === '001' || str == '5') { //零售
                num = 'YPLS'
            } else if (str === '010' || str == '4') {//批发
                num = 'YPCY'
            }
            return num
      },
      gqpx2 (str) {
        let num;
            if (str === 'YLQX') {
                num = '6'
            } else if (str === 'YPLS') {
                num = '5'
            } else if (str === 'YPCY') {
                num = '4'
            }
            return num
      },
      gqpx3 (str) {
        let num;
            if (str === 'YLQX') {
                num = '100'
            } else if (str === 'YPLS') {
                num = '001'
            } else if (str === 'YPCY') {
                num = '010'
            }
            return num
      },
      enrollStr (str) {
        let str2 = ''
        if (str === 'face') {
            str2 = '函授'
        } else if (str === 'online') {
            str2 = '网络'
        } else if (str === 'repair') {
            str2 = '补修'
        }
        return str2
      },
      clear () {
        window.localStorage.clear();
      },
      courseIndex: {
        set (num) {
            window.localStorage.setItem("courseIndex", num);
        },
        get () {
            return window.localStorage.getItem('courseIndex');
        },

      },
      token: {
        set (token) {
              window.localStorage.setItem("token", token);
          },
          get () {
              return window.localStorage.getItem('token');
          },
        remove () {
          window.localStorage.removeItem('token')
        }
      },
      news: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("newsIndex", str);
        },
        get () {
          return window.localStorage.getItem('newsIndex');
        },
        setList (str) {
            window.localStorage.setItem("Keyword", str);
        },
        getList () {
            return   window.localStorage.getItem("Keyword");
        }
      },
      userName: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("userName", str);
        },
        get () {
          return window.localStorage.getItem('userName');
        },
      },
      courseId: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("courseNum", str);
        },
        get () {
          return window.localStorage.getItem('courseNum');
        },
      },
      enroll: {
        set (str) { // 获取详细的新闻
          window.localStorage.setItem("enrollName", str);
        },
        get () {
          return window.localStorage.getItem('enrollName');
        },
      },
      info: {
        set (str) { // 获取详细的新闻
         window.localStorage.setItem("info", str);
        },
        get () {
         return window.localStorage.getItem('info');
        }, 
      }
    }
    export default utils
    


// WEBPACK FOOTER //
// ./src/utils/index.js